import React from 'react';
import { numberFormat, replaceVal } from '../../../../utils/formatting';
import { __ } from '../../../../utils/translation-service';
import {
    StyledAmountOfRatings,
    StyledArrow,
    StyledContentWrapper,
    StyledRatingString,
    StyledRatingValue,
    StyledRatingValueBox,
    StyledRatingWrapper,
} from './rating-big.style';

interface IRating {
    value: number;
    base?: number;
    string: string;
    amount: number;
}

export const RatingBig: React.FunctionComponent<IRating> = ({
    value,
    base = 10,
    string,
    amount,
}) => {
    return (
        <StyledRatingWrapper data-testid={'rating-big-component'}>
            <StyledRatingValueBox>
                <StyledRatingValue>{value}</StyledRatingValue> / {base}
            </StyledRatingValueBox>
            <StyledArrow />
            <StyledContentWrapper>
                <StyledRatingString>{string}</StyledRatingString>
                {amount && amount > 0 && (
                    <StyledAmountOfRatings data-testid={'rating-big-component-total-amount'}>
                        {replaceVal(
                            __('reviews'),
                            numberFormat(amount, { maxDecimals: 1 }),
                            /\[amount]/g,
                        )}
                    </StyledAmountOfRatings>
                )}
            </StyledContentWrapper>
        </StyledRatingWrapper>
    );
};
